import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as actions from './stock.actions';
import { PowerBIUrlLoadAction, StockLoadAction } from './stock.actions';
import { Observable, of } from 'rxjs';
import { RootState } from '..';
import { StockRestService } from '../../services/rest/stock.rest.service';
import { AbstractEffects } from '../AbstractEffects';
import { TranslateService } from '@ngx-translate/core';
import { AzureMonitoringService } from '../../services/AzureMonitoringService';
import { catchError, debounceTime, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { NotificationService } from 'app/core/services/notification.service';

@Injectable({ providedIn: 'root' })
export class StockEffects extends AbstractEffects {
  loadStock$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<StockLoadAction>(actions.STOCK_LOAD),
      debounceTime(50),
      withLatestFrom(this.store, (action: StockLoadAction, state) => {
        return { payload: action.payload, state };
      }),
      switchMap(
        (
          { payload, state } // Register to this event, unregister previous if new event occurs.
        ) =>
          this.stockRestService
            .getStock(payload.filter) // Request stock
            .pipe(
              map(
                stockArray =>
                  new actions.StockLoadSuccessAction(
                    Object.assign({}, stockArray, {
                      definitions: state.definitions,
                      places: state.contractDetails.places,
                      filter: payload.filter,
                    })
                  )
              ),
              catchError(err => this.handleFail(err, 'ERRORS.FILTER_FAILED.TITLE', [of(new actions.StockLoadFailAction(err))]))
            )
      )
    )
  );
  loadPowerBIUrl$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<PowerBIUrlLoadAction>(actions.POWER_BI_URL_LOAD),
      debounceTime(50),
      switchMap(() => {
        return this.stockRestService.getPowerBIUrl().pipe(
          map(result => new actions.PowerBIUrlLoadSuccessAction(result)),
          catchError(err => this.handleFail(err, 'Load Power BI URL', [of(new actions.PowerBIUrlLoadFailAction(err))]))
        );
      })
    )
  );

  constructor(
    private store: Store<RootState>,
    azureMonitoringService: AzureMonitoringService,
    private actions$: Actions,
    private stockRestService: StockRestService,
    translateService: TranslateService,
    notificationService: NotificationService
  ) {
    super(translateService, azureMonitoringService, notificationService);
  }
}
